import { api } from '@/services/api'
import { SET, SET_VALUE, PUSH, MERGE, MERGE_ARRAY, DELETE_ITEM_ARRAY, MERGE_ITEM_ARRAY, UPDATE } from '@/plugins/store/mutationTypes'
import { ServiceRFQs } from '@/services/RFQs'
import { ServiceCustomerPOFollowUp } from '@/services/CustomerPOFollowUp'
import { getDefaultOrderPhaseID } from '@/utils/shared'

const state = {
  isLoading: false,
  dataRFQ: {},
  listRFQ1: [],
  listRFQ3: [],
  fieldPO: null
}
const getters = {
  mapListRFQ3: (state) => {
    return state['listRFQ3'].reduce((result, item) => {
      result[item.rfqid + '__' + item.partID] = item
      return result
    }, {})
  },
  completeStep1: (state) => {
    return !!Object.keys(state['dataRFQ']).length
  },
  completeStep2: (state, getters) => {
    return getters['completeStep1']
  },
  completeStep3: (state, getters) => {
    return getters['completeStep2'] &&
      state['dataRFQ'].customerCompanyID &&
      state['dataRFQ'].customerCompanyDetailID &&
      state['listRFQ1'].length
  }
}
const mutations = {
  SET,
  UPDATE,
  SET_VALUE,
  MERGE,
  PUSH,
  MERGE_ARRAY,
  MERGE_ITEM_ARRAY,
  DELETE_ITEM_ARRAY
}
const actions = {
  resetState ({ commit }) {
    return Promise.resolve()
      .then(() => {
        commit('SET', { key: 'dataRFQ', value: {} })
        commit('SET', { key: 'fieldPO', value: null })
        commit('SET', { key: 'listRFQ1', value: [] })
        commit('SET', { key: 'listRFQ3', value: [] })
        commit('SET', { key: 'isLoading', value: false })
      })
  },
  createPO ({ commit, dispatch }, dataPO) {
    commit('SET', { key: 'isLoading', value: true })
    return ServiceRFQs.createPO(dataPO)
      .then(() => {
        commit('UPDATE', { key: 'dataRFQ', value: dataPO })
      })
      .then(() => {
        return dispatch('createCustomerFollowUps')
      })
      .then(() => {
        commit('SET', { key: 'isLoading', value: false })
      })
      .catch((e) => {
        commit('SET', { key: 'isLoading', value: false })
        throw e
      })
  },
  checkMultipleRFQ3 ({ state, commit }, payload) {
    const { value, data } = payload
    const rfq3ID = data.id
    const newList = state.listRFQ3.map((item) => {
      let newItem = { ...item }
      newItem._includeMultiple = rfq3ID === item.id ? value : !!item._includeMultiple
      return newItem
    })

    commit('SET', { key: 'listRFQ3', value: newList })
    return Promise.resolve(newList)
  },
  createCustomerFollowUps ({ state }) {
    const { dataRFQ, listRFQ3 } = state
    const orderPhaseID = getDefaultOrderPhaseID()

    const listRFQ3Chosen = listRFQ3.filter((itemRFQ3) => itemRFQ3.chosen)

    return Promise.all(listRFQ3Chosen.map((itemRFQ3) => {
      const data = {
        rfqid: dataRFQ.rfqid,
        partID: itemRFQ3.partID,
        partSN: itemRFQ3.partSN,
        reminderDate: null,
        priorityID: dataRFQ.priorityID,
        po: dataRFQ.po,
        rfQ3ID: itemRFQ3.id,
        stockID: itemRFQ3.stockID,
        customerID: dataRFQ.customerCompanyID,
        orderPhaseID,
        orderPhasePersonInChargeEmployeeID: dataRFQ.baxEmployeeID
      }
      return ServiceCustomerPOFollowUp.createFromRFQPending(data)
    }))
  },
  addRFQ1ToRFQ3 ({ commit, getters }, data) {
    let _data = { ...data }
    delete _data.id
    commit('SET', { key: 'isLoading', value: true })
    return api
      .post(`RFQ3s/Create`, JSON.parse(JSON.stringify(_data)))
      .then((response) => {
        commit('SET', { key: 'isLoading', value: false })
      })
      .catch((err) => {
        commit('SET', { key: 'isLoading', value: false })
        throw err
      })
  }
}
export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
